module.exports="abcwebpack"


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/module-description-file/~/testloader/lib/loader.webpack-loader.js!./loaders/_resources/abc.txt
 ** module id = 4
 ** module chunks = 0
 **/